import { render, staticRenderFns } from "./api.vue?vue&type=template&id=8a9dd46c&scoped=true&"
import script from "./api.vue?vue&type=script&lang=js&"
export * from "./api.vue?vue&type=script&lang=js&"
import style0 from "./api.vue?vue&type=style&index=0&id=8a9dd46c&lang=scss&scoped=true&"
import style1 from "./api.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9dd46c",
  null
  
)

export default component.exports